"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var cerealParse_1 = require("../../cerealParse");
var models_1 = require("../../models");
/** StreamMixin classes */
var StreamMixin = /** @class */ (function () {
    function StreamMixin() {
    }
    /**
     * searchStreams
     * @param query
     * @param callback
     */
    StreamMixin.prototype.searchStreams = function (query, callback) {
        var _this = this;
        var urlParams = { query: query };
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.AudioStream.parse, 'warn'));
        };
        this.http.get('/streams', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getStream
     * @param id
     * @param callback
     */
    StreamMixin.prototype.getStream = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AudioStream.parse));
        };
        this.http.get("/streams/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editStream
     * @param id
     * @param name
     * @param url
     * @param callback
     */
    StreamMixin.prototype.editStream = function (id, name, url, callback) {
        var _this = this;
        var body = {
            name: models_1.FieldUtils.getEditableParam(name),
            url: models_1.FieldUtils.getEditableParam(url),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/streams/" + id, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * createStream
     * @param name
     * @param url
     * @param callback
     */
    StreamMixin.prototype.createStream = function (name, url, callback) {
        var _this = this;
        var body = {
            name: name,
            url: url,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AudioStream.parse));
        };
        this.http.post('/streams', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * deleteStream
     * @param id
     * @param callback
     */
    StreamMixin.prototype.deleteStream = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/streams/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * runSashCommand
     * @param scuId
     * @param command
     * @param wait
     * @param args
     * @param callback
     */
    StreamMixin.prototype.runSashCommand = function (scuId, command, wait, args, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SashResponse.parse));
        };
        var body = {
            wait: wait,
            command: command,
            args: args,
        };
        this.http.post("/scus/" + scuId + "/sash", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * loadSashResponse
     * @param sashId
     * @param callback
     */
    StreamMixin.prototype.loadSashResponse = function (sashId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SashResponse.parse));
        };
        this.http.get("/scus/sash/" + sashId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * runTestTranslation
     * @param scuId
     * @param raw
     * @param type
     * @param callback
     */
    StreamMixin.prototype.runTestTranslation = function (scuId, raw, type, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                try {
                    return cerealParse_1.ParseUtils.parseSuccess(cerealParse_1.ParseUtils.getString(o, 'translation'));
                }
                catch (e) {
                    return cerealParse_1.ParseUtils.parseFailure("Invalid Translation: " + e.message);
                }
            }));
        };
        var urlParams = {
            raw: raw,
            type: type,
        };
        this.http.get("/scus/" + scuId + "/translate", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editScuCts
     * @param scuId
     * @param device
     * @param input
     * @param output
     * @param timeout
     * @param inputType
     * @param radioType
     * @param callback
     */
    StreamMixin.prototype.editScuCts = function (scuId, device, input, output, timeout, inputType, radioType, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            clearToSend: {
                device: device,
                input: input,
                output: output,
                timeout: timeout,
                inputType: models_1.SCUIODeviceInputCondition[inputType],
                radioType: models_1.SCURadioType[radioType],
            },
        };
        this.http.put("/scus/" + scuId + "/config", null, body, wrappedCallback);
    };
    /**
     * deleteScuCts
     * @param scuId
     * @param callback
     */
    StreamMixin.prototype.deleteScuCts = function (scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/scus/" + scuId + "/config/clear-to-send", null, wrappedCallback);
    };
    return StreamMixin;
}());
exports.default = StreamMixin;
//# sourceMappingURL=StreamMixin.js.map